import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Get public CMS content by page & language
 * @param {string} page - e.g. "mhero1"
 * @param {string} language - "en" | "ar" | "ku"
 */
export const getPageContent = async (page, language) => {
  if (!page) throw new Error("page is required");
  if (!language) throw new Error("language is required");

  const response = await axios.get(`${API_BASE_URL}/content`, {
    params: {
      page,
      language,
    },
  });

  return response.data;
};
